export default "__VITE_ASSET__PHkKHbLG__"